import { useState, useContext, useEffect, forwardRef } from 'react';
import { 
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
} from '@mui/material';
import {
  Edit as EditIcon,
} from '@mui/icons-material';
import { NumericFormat } from 'react-number-format';
import { AuthContext } from 'components';

const NumericFormatCustom = forwardRef(function NumericFormatCustom(
  props,
  ref,
) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      valueIsNumericString
    />
  );
});


export const BudgetEdit = (props) => {
  const { budget, category, season, collection } = props;
  const [ value, setValue ] = useState(budget ? budget.toString().replaceAll(',', '') : null)
  const [ open, setOpen ] = useState(false);
  const { selectedStore, selectedSeason, updateBudget, updateSeasonCollectionBudget } = useContext(AuthContext);


  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    setValue(budget)
  }, [budget])

  const handleSave = () => {
    if (season) {
      updateSeasonCollectionBudget(season, parseFloat(value), handleClose)
    } else {
      updateBudget(selectedStore, collection || selectedSeason, category.category_group_id, category.category_id, parseFloat(value), handleClose)
    }
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSave();
      event.stopPropagation();
    }
  };

  if (open) {
    // console.log('PDP:', props, budget, value);
  }

  return (
    <div>
      <IconButton onClick={handleOpen} size="small" color="secondary">
        <EditIcon fontSize="small" sx_={{ fontSize: 16 }} />
      </IconButton>
      { budget }
      <Dialog onKeyDown={handleKeyDown} open={open} onClose={handleClose}>
        <DialogContent>
          <TextField
            variant='standard'
            label="Edit budget"
            InputLabelProps={{ shrink: true }}
            autoFocus
            value={value !== 0 ? value : null}
            InputProps={{
              inputComponent: NumericFormatCustom,
            }}
            onChange={(e) => { setValue(e.target.value) }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave}>Save</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}